import PhotoItem from "./PhotoItem";

export default PhotoItem;
